export const SidebarCardIcon = ({ className = '' }: { className?: string }) => (
  <svg
    className={className}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1667 9.16667H1.83333M10.0833 12.8333H5.5M1.83333 7.51667V14.4833C1.83333 15.5101 1.83333 16.0235 2.03316 16.4157C2.20892 16.7606 2.48938 17.0411 2.83435 17.2168C3.22652 17.4167 3.7399 17.4167 4.76667 17.4167H17.2333C18.2601 17.4167 18.7735 17.4167 19.1657 17.2168C19.5106 17.0411 19.7911 16.7606 19.9668 16.4157C20.1667 16.0235 20.1667 15.5101 20.1667 14.4833V7.51667C20.1667 6.48991 20.1667 5.97652 19.9668 5.58435C19.7911 5.23939 19.5106 4.95893 19.1657 4.78316C18.7735 4.58333 18.2601 4.58333 17.2333 4.58333H4.76667C3.73991 4.58333 3.22652 4.58333 2.83435 4.78316C2.48939 4.95892 2.20892 5.23938 2.03316 5.58435C1.83333 5.97652 1.83333 6.4899 1.83333 7.51667Z"
      stroke="white"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
